export default __webpack_public_path__ + "static/media/workers.ec0449e0.svg";